var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-pt-7 tw-pb-40 tw-px-5"},[_c('nuxt'),_vm._v(" "),(_vm.$accessor.misc.bottomNavShow)?_c('customer-bottom-nav',{attrs:{"is-guest":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }